import { useContext } from 'react';

import ClockIcon from 'assets/icons/clock.svg';
import MailIcon from 'assets/icons/mail-small.svg';
import { ConfigContext } from '@providers/ConfigProvider';
import PhoneNumber from '@components/atoms/PhoneNumber';
import Typography from '@components/atoms/Typography';
import Link from '@components/atoms/Link';
import { FormattedMessage } from 'utils/intl';

import classes from './FooterContactUs.module.scss';
import messages from './FooterContactUs.messages';

const FooterContactUs = () => {
  const { contact } = useContext(ConfigContext);

  return (
    <>
      <Typography variant="body2" weight="700">
        <FormattedMessage {...messages.header} />
      </Typography>
      <div className={classes.contactWrapper}>
        <Typography variant="body2" className={classes.openingHours}>
          <ClockIcon className={classes.icon} />
          {contact.openingHours}
        </Typography>
        <PhoneNumber tel={contact.landlinePhone} variant="landline" weight="400" />
        {!!contact.cellPhone && <PhoneNumber tel={contact.cellPhone} variant="mobile" weight="400" />}
        <Link href={`mailto:${contact.contactEmail}`}>
          <Typography className={classes.email} variant="body2">
            <MailIcon className={classes.icon} />
            {contact.contactEmail}
          </Typography>
        </Link>
      </div>
    </>
  );
};

export default FooterContactUs;
